import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { scrollToTop } from "../../../services";

// ~ This component is not necessary, it'should be removed
const PaginationUser = props => {
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);

  useEffect(() => {
    setTotal(props.total);
  }, [total]);

  useEffect(() => {
    setCurrent(props.current);
  }, [current]);

  const onPageChange = page => {
    const { onPageChange } = props;
    onPageChange(page);
    scrollToTop();
  };

  return (
    <Pagination
      className={props.className}
      total={total}
      current={current}
      onChange={onPageChange}
    />
  );
};

PaginationUser.defaultProps = {
  className: "",
  current: 1
};

export default PaginationUser;



// WEBPACK FOOTER //
// ./src/routes/Admin/PaginationUser/PaginationUser.tsx